import { TextFieldProps } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import React, { FC } from 'react';
import { forwardRef } from 'react';
import { useState } from 'react';
import PhoneInput, { formatPhoneNumberIntl } from 'react-phone-number-input';

import CustomSelect from '../CustomSelect';
import CustomTextField from '../CustomTextField';
import { CountryCode } from 'libphonenumber-js';

const CustomMuiPhoneInput = (props: any, ref: any) => (
  <Box style={{ flexGrow: 0.7, marginLeft: 12 }}>
    <CustomTextField {...props} inputRef={ref} name="phone" />
  </Box>
);

const CustomInput = forwardRef(CustomMuiPhoneInput);

const CustomMuiCountrySelect = ({ value, onChange, options, ...rest }: any) => (
  <Box style={{ flexGrow: 0.3 }}>
    <CustomSelect
      {...rest}
      options={options}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      label="Pays"
    />
  </Box>
);

interface CustomPhoneInputProps {}

const CustomPhoneInput: FC<CustomPhoneInputProps & TextFieldProps> = (
  props,
) => {
  const [country, setCountry] = useState<CountryCode>('FR');
  return (
    // @ts-ignore
    <PhoneInput
      {...props}
      value={formatPhoneNumberIntl(props?.value as string)}
      style={{ display: 'flex' }}
      inputComponent={CustomInput}
      countrySelectComponent={CustomMuiCountrySelect}
      country={country}
      defaultCountry={country}
      onCountryChange={(country) => setCountry(country || 'FR')}
    />
  );
};

export default CustomPhoneInput;
